import React from "react";
import { Tooltip } from "@material-ui/core";
import styled from "styled-components";
import { theme } from "./theme";
import { hexToRgba } from "../utils/hexToRgba";
import IncidentType from "types/IncidentType";

const PredictionIntervalItem = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  user-select: none;
  pointer-events: none;
  border-radius: ${theme.borderRadius.medium};  
  background-image: repeating-linear-gradient(
    -45deg,
    transparent,
    transparent 4px,
    rgba(0, 0, 0, 0.08) 4px,
    rgba(0, 0, 0, 0.08) 8px
  );
`;

export interface IncidentPredictionIntervalItemProps {
  incident: IncidentType;
  clientWidth: number;
  totalFrames: number;
  currentFrame: number;
  topOffset?: number;
  showLabel?: boolean;
}

const PREDICTION_BAR_HEIGHT = 24;

const IncidentPredictionIntervalItem: React.FC<
  IncidentPredictionIntervalItemProps
> = ({
  incident,
  clientWidth,
  totalFrames,
  currentFrame,
  topOffset = 38,
  showLabel = true,
}) => {
  const color = hexToRgba(incident.class?.color || theme.colors.background, 0.35);
  const endFrame = incident.endFrame ?? currentFrame;
  const width =
    totalFrames > 0
      ? ((endFrame - incident.startFrame) * clientWidth) / totalFrames
      : 0;
  const left =
    totalFrames > 0 ? (incident.startFrame * clientWidth) / totalFrames : 0;
  const title = `${incident.class?.name ?? ""} (prédiction)`;

  return (
    <Tooltip title={title}>
      <span
        style={{
          position: "absolute",
          left,
          top: topOffset,
          width: Math.max(width, 4),
          height: PREDICTION_BAR_HEIGHT,
          display: "inline-block",
        }}
      >
        <PredictionIntervalItem
          style={{
            backgroundColor: color,
          }}
        >
          {showLabel && (
            <p
              style={{
                margin: "0 4px",
                lineHeight: `${PREDICTION_BAR_HEIGHT}px`,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                color: incident.class?.color,
                fontSize: "0.7em",
                fontWeight: 600,
                filter: "brightness(0.65)",
                opacity: 0.85,
              }}
            >
              {incident.class?.name}
            </p>
          )}
        </PredictionIntervalItem>
      </span>
    </Tooltip>
  );
};

export default IncidentPredictionIntervalItem;
